import HCLTreeVertexValue from '../HCLTreeVertexValue/HCLTreeVertexValue';
import Label from "../HCLTreeVertexValue/Label";
import {BayesianNodeJSON, BayesianNodeStateJSON} from "../../HCLTreeMxGraph/BayesianNetworkMxGraph";
import Outcome, {OutcomeJSON} from "../HCLTreeVertexValue/Outcome";
import Expression from "../HCLTreeVertexValue/Expression";
import ReferenceTypes from "../HCLTreeVertexValue/ReferenceTypes";

class BayesianNetworkVertexValue extends HCLTreeVertexValue {

  private states: {[key: string]: BayesianNodeStateJSON};
  private dependencies: OutcomeJSON[];

  constructor(label?: Label, states?: {[key: string]: BayesianNodeStateJSON}, dependencies?: OutcomeJSON[]) {
    super(label || new Label("Node", ""));

    this.states = states || {
      T: {
        probabilities: [
          {
            expression: new Expression().toJSON(),
            states: []
          }
        ]
      },
      F: {
        probabilities: [
          {
            expression: new Expression().toJSON(),
            states: []
          }
        ]
      }
    };
    this.dependencies = dependencies || [];
  }

  /**
   * @return {[key: string]: BayesianNodeStateJSON}
   */
  getStates(): {[key: string]: BayesianNodeStateJSON} {
    return this.states;
  }

  /**
   * @param {[key: string]: BayesianNodeStateJSON} states
   */
  setStates(states: {[key: string]: BayesianNodeStateJSON}): void {
    this.states = states;
  }

  /**
   * @return {OutcomeJSON[]}
   */
  getDependencies(): OutcomeJSON[] {
    return this.dependencies;
  }

  /**
   * @param {OutcomeJSON[]} dependencies
   */
  setDependencies(dependencies: OutcomeJSON[]): void {
    this.dependencies = dependencies;
  }

  toJSON(): BayesianNodeJSON {
    return ({
      ...super.toJSON(),
      states: this.getStates(),
      dependencies: this.getDependencies()
    })
  }

  cloneState() {
    const states: { [key: string]: BayesianNodeStateJSON } = {};
    Object.keys(this.states).map(stateName => {
      states[stateName] = {
        probabilities: this.states[stateName].probabilities.map(probability => {
          return {
            expression: new Expression(probability.expression).clone().toJSON(),
            states: (probability.states || []).map(state => Outcome.build(state).clone().toJSON())
          }
        })
      }
    });
    return states;
  }

  clone(): BayesianNetworkVertexValue {
    return new BayesianNetworkVertexValue(this.label.clone(), this.cloneState(), null);
  }

}

export default BayesianNetworkVertexValue;
